module.exports = __webpack_public_path__ + "img/Vangsgutane_Tegneserier_i_ukeblad.cd022e5b.jpg";